import React from "react";
import { Table } from "@chakra-ui/react";

function Component({
  columnDefs,
  tableData,
}: {
  columnDefs: any;
  tableData: any;
}) {
  var cols = columnDefs;
  return (
    <Table.Root size="sm">
      <Table.Header>
        <Table.Row>
          {cols.map((col: any) => (
            <Table.ColumnHeader>{col}</Table.ColumnHeader>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {tableData?.map((item: any, index: number) => (
          <Table.Row key={index}>
            {cols.map((col: any) => (
              <Table.Cell>{item[col]}</Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
}

export default Component;
